
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as cguqfEWRrwiIWsUHzjgoGhnP5ttRPqtcTe4zbD1J3yhGwsMeta } from "/app/pages/cgu.vue?macro=true";
import { default as cgvynks6kmCFJYVqYcA9ll84d_45UPnj6lVrtJm6jV9ALMBwMeta } from "/app/pages/cgv.vue?macro=true";
import { default as privacyxyrJyjSeOpGN_D08QZsO5Csr7DLueZBtja09XVxe_45u0Meta } from "/app/pages/privacy.vue?macro=true";
import { default as indexgxeoLanSNgYaOFH_tdrMytbgJ5yk1XLcZ3i6dZveUgYMeta } from "/app/layers/social-studio/pages/xtranet/social-studio/index.vue?macro=true";
import { default as indexpBmY9pn2HvN5jzMjX214lqq9UVc6gH8mkQsQndZ4fXkMeta } from "/app/layers/strategic-hub/pages/xtranet/strategic-hub/index.vue?macro=true";
import { default as create8hY2CQQHmM_45kQW6xgtqOwtPO30ZBTXZVT73QcfCrDBwMeta } from "/app/layers/social-studio/pages/xtranet/social-studio/create.vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "cgu___fr",
    path: "/fr/cgu",
    component: () => import("/app/pages/cgu.vue")
  },
  {
    name: "cgu___en",
    path: "/en/cgu",
    component: () => import("/app/pages/cgu.vue")
  },
  {
    name: "cgu___de",
    path: "/de/cgu",
    component: () => import("/app/pages/cgu.vue")
  },
  {
    name: "cgv___fr",
    path: "/fr/cgv",
    component: () => import("/app/pages/cgv.vue")
  },
  {
    name: "cgv___en",
    path: "/en/cgv",
    component: () => import("/app/pages/cgv.vue")
  },
  {
    name: "cgv___de",
    path: "/de/cgv",
    component: () => import("/app/pages/cgv.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "privacy___fr",
    path: "/fr/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___de",
    path: "/de/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "xtranet-social-studio___fr",
    path: "/fr/xtranet/social-studio",
    meta: { ...(indexgxeoLanSNgYaOFH_tdrMytbgJ5yk1XLcZ3i6dZveUgYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/layers/social-studio/pages/xtranet/social-studio/index.vue")
  },
  {
    name: "xtranet-social-studio___en",
    path: "/en/xtranet/social-studio",
    meta: { ...(indexgxeoLanSNgYaOFH_tdrMytbgJ5yk1XLcZ3i6dZveUgYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/layers/social-studio/pages/xtranet/social-studio/index.vue")
  },
  {
    name: "xtranet-social-studio___de",
    path: "/de/xtranet/social-studio",
    meta: { ...(indexgxeoLanSNgYaOFH_tdrMytbgJ5yk1XLcZ3i6dZveUgYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/layers/social-studio/pages/xtranet/social-studio/index.vue")
  },
  {
    name: "xtranet-strategic-hub___fr",
    path: "/fr/xtranet/strategic-hub",
    meta: { ...(indexpBmY9pn2HvN5jzMjX214lqq9UVc6gH8mkQsQndZ4fXkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/layers/strategic-hub/pages/xtranet/strategic-hub/index.vue")
  },
  {
    name: "xtranet-strategic-hub___en",
    path: "/en/xtranet/strategic-hub",
    meta: { ...(indexpBmY9pn2HvN5jzMjX214lqq9UVc6gH8mkQsQndZ4fXkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/layers/strategic-hub/pages/xtranet/strategic-hub/index.vue")
  },
  {
    name: "xtranet-strategic-hub___de",
    path: "/de/xtranet/strategic-hub",
    meta: { ...(indexpBmY9pn2HvN5jzMjX214lqq9UVc6gH8mkQsQndZ4fXkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/layers/strategic-hub/pages/xtranet/strategic-hub/index.vue")
  },
  {
    name: "xtranet-social-studio-create___fr",
    path: "/fr/xtranet/social-studio/create",
    meta: { ...(create8hY2CQQHmM_45kQW6xgtqOwtPO30ZBTXZVT73QcfCrDBwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/layers/social-studio/pages/xtranet/social-studio/create.vue")
  },
  {
    name: "xtranet-social-studio-create___en",
    path: "/en/xtranet/social-studio/create",
    meta: { ...(create8hY2CQQHmM_45kQW6xgtqOwtPO30ZBTXZVT73QcfCrDBwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/layers/social-studio/pages/xtranet/social-studio/create.vue")
  },
  {
    name: "xtranet-social-studio-create___de",
    path: "/de/xtranet/social-studio/create",
    meta: { ...(create8hY2CQQHmM_45kQW6xgtqOwtPO30ZBTXZVT73QcfCrDBwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/layers/social-studio/pages/xtranet/social-studio/create.vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]